import {AdvertModel} from './AdvertModel';

export class GymInfo {
  gymName: string;
  contactNumber: string;
  email: string;
  gymID: string;
  gymUID: string;
  active: number;
  logoURL: string;
  lat: number;
  long: number;
  gymAddress: string;
  advertisement: AdvertModel;
  profileImageURL: string;
  personName: string;
  createdOn: '';
  createdBy: '';
  updatedOn: '';
  updatedBy: '';

  // constructor(gymName: string, contactNumber: number, email: string, gymID: string, gymUID: string, active: number, logoURL: string, lat: number, long: number, gymAddress: string, private AdvertModel, profileImageURL: string) {
  //   this.gymName = gymName;
  //   this.contactNumber = contactNumber;
  //   this.email = email;
  //   this.gymID = gymID;
  //   this.gymUID = gymUID;
  //   this.active = active;
  //   this.logoURL = logoURL;
  //   this.lat = lat;
  //   this.long = long;
  //   this.gymAddress = gymAddress;
  //   this.advertisement = AdvertModel;
  //   this.profileImageURL = profileImageURL;
  // }
}



// WEBPACK FOOTER //
// ./src/app/_models/_firebaseObjects/GymInfo.ts